import React, { Component } from 'react'
import { connect } from 'react-redux'
import FutureElevation from '../../../widgets/FutureElevation';
import { updateElevation } from '../../../../store/actions/sketchActions';
import Loader from 'react-loader-spinner';
import { get } from 'lodash'

class EditElevation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            coordinates: [],
            title: "",

            descriptionCount: 0,
            description: "",

            floorsMap: {},
            newFiles: [],
            imageFilesList: [],
            files: [],
        }
    }

    /// README: TITLE AND DESCRIPTION STATE CHANGES
    handleChange = (e) => {
        switch (e.target.id) {
            case "editCoordinates": {
                var coordinatesStringList = `${e.target.value}`.split(",");
                var coordinates = coordinatesStringList.map((e) => Number.isNaN(Number.parseFloat(e)) ? 0 : Number.parseFloat(e))
                coordinates = (coordinates.length < 2 ? [...coordinates, 0] : coordinates).slice(0, 2);
                console.log(coordinates)
                this.setState({
                    coordinates,
                })
                break;
            }
            case "editTitle": {
                this.setState({
                    title: e.target.value,
                })
                break;
            }
            case "editDescription": {
                this.setState({
                    descriptionCount: e.target.value.length,
                    description: e.target.value,
                })
                break;
            }
            default:
        }
    }

    /// README: UTILS
    toLowercaseWithoutSpaces = (val) => {
        return val.replaceAll(/[/\-.\s]/g, '').toLowerCase();
    }

    removePdfExt = (val) => {
        const extLength = 'pdf'.length;
        return val.substring(0, val.length - extLength);
    }

    /// README: HANDLING PDF FILES ADDITIONS
    onFilesAddHandler = (e) => {
        if (this.maxSelectFile(e) && this.checkMimeType(e) && this.checkFileSize(e)) {
            var filteredFiles = this.removeRedundantFilenames(e.target.files);
            this.setState(() => ({ newFiles: [...filteredFiles] }));
        }
    }

    removeRedundantFilenames = (files) => {
        const { imageFilesList } = this.state;

        // check if files not already in imageFilesList
        var filteredFiles = [...files].filter(s => imageFilesList.every(t => {
            return this.processFilenames(s.name) !== t
        }));

        return filteredFiles;
    }

    processFilenames = (filename) => {
        return this.removePdfExt(this.toLowercaseWithoutSpaces(filename));
    }

    maxSelectFile = (e) => {
        const { files } = this.state;
        let pickedFiles = e.target.files;
        const definedLimit = 20 - files.length;

        if (pickedFiles.length > definedLimit) {
            const msg = `Only ${definedLimit} more image(s) can be attached with this elevation.`
            e.target.value = null
            alert(msg)
            return false;
        }
        return true;
    }

    checkFileSize = (e) => {
        let pickedFiles = e.target.files
        let size = 5242880;
        let err = "";
        for (var x = 0; x < pickedFiles.length; x++) {
            if (pickedFiles[x].size > size) {
                err = 'File is too large, please pick a smaller file\n';
            }
        };
        if (err !== '') {
            e.target.value = null
            return false
        }
        return true;
    }

    checkMimeType = (e) => {
        let pickedFiles = e.target.files
        let err = ''
        const types = ['application/pdf']
        for (var x = 0; x < pickedFiles.length; x++) {
            if (!types.includes(pickedFiles[x].type)) {
                err = 'File is not in a supported format\n';
            }
        };
        if (err !== '') {
            e.target.value = null // discard selected file
            return false;
        }
        return true;
    }

    /// README: SUBMITTING THE FORM
    handleSubmit = (e) => {
        e.preventDefault();

        const { coordinates, title, description, newFiles, floorsMap } = this.state;
        const { project, selectedMarkerid } = this.props;
        const { floorMeta } = project;

        this.props.updateElevation(
            selectedMarkerid,
            floorMeta.proid,
            floorMeta.floorid,
            floorsMap,
            coordinates,
            newFiles,
            title,
            description,
        )
    }

    /// README: Choose elevation to open
    chooseElevation = (elevationid, elevationMap) => {
        const elevationidMap = { floodid: elevationid };
        const elevationMeta = { ...elevationMap, ...elevationidMap };
        this.props.setCurrentElevationMeta(elevationMeta);
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('dateCreated' in a && 'dateCreated' in b) {
            if (a.dateCreated && b.dateCreated) {
                if (a.dateCreated.seconds < b.dateCreated.seconds) {
                    return -1;
                }
                if (a.dateCreated.seconds > b.dateCreated.seconds) {
                    return 1;
                }
            }
        }
        return 0;
    }

    componentDidMount() {
        const { selectedMarkerid, floorMarkers } = this.props;
        console.log(floorMarkers[selectedMarkerid], "marker data");
        this.setState({
            ...floorMarkers[selectedMarkerid],
        })
    }

    render() {
        const { formLabelStyle, mut, snagDetail, sketch, themeColors, commons } = this.props;
        const { isMarkerUpdating } = sketch;

        /// this is placed to pause snagDetail related stuff while snagDetail is not available
        if (!snagDetail) {
            return <React.Fragment />
        }

        const { title, description, floorsMap, newFiles, coordinates } = this.state;
        const descriptionCount = description.length;
        const markerTitle = mut.text["1"];
        console.log(coordinates);

        const relevantSubmitComponent = isMarkerUpdating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br />

                <br />
            </React.Fragment>) :
            <button className="btn btn-dark btn-sm">Update this {markerTitle}</button>;

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    {/* Title and description */}
                    <div className="form-group text-left">
                        <label htmlFor="inputText" style={formLabelStyle}>Title *</label>
                        <input type="text" className="form-control form-control-sm" id="editTitle" onChange={this.handleChange} defaultValue={title} required />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="inputText" style={formLabelStyle}>Description *</label>
                        <span className="ml-3" style={{ fontSize: "12px", color: "GrayText" }}>({descriptionCount}/200)</span>
                        <textarea maxLength="200" rows="3" className="form-control form-control-sm" id="editDescription" onChange={this.handleChange} defaultValue={description} required />
                    </div>
                    {/* <div className="form-group text-left">
                    <label htmlFor="inputText" style={formLabelStyle}>Coordinates</label>
                    <input type="text" className="form-control form-control-sm" id="editCoordinates" onChange={this.handleChange} defaultValue={coordinates} />
                    <input type="text" className="form-control form-control-sm" id="noEditCoordinates" placeholder={"0,0"} value={`Saved as: ${coordinates}`} readOnly />
                </div> */}
                    <hr />
                    {/* Uploaded files display */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Added new {commons.drawings} *</label>
                        <br />
                        <div className="card">
                            <div className="m-3">
                                {floorsMap !== undefined ? floorsMap !== null ? Object.keys(floorsMap).length !== 0 ? Object.values(floorsMap).sort(this.compare).map((val, i) => (
                                    <div key={i}>
                                        <button type="button" className="btn btn-flat btn-sm" style={{ fontStyle: "normal", fontSize: "16px", fontWeight: "normal" }} data-toggle="tooltip" data-placement="top" title={val.name}>
                                            {i + 1}. {val.name.length > 40 ? `${val.name.substring(0, 40)}...` : `${val.name}`}
                                        </button>
                                        <span style={{ fontStyle: "italic", fontSize: "12px", color: "GrayText" }}>
                                            <FutureElevation isCirclePreview={false} elevationMap={val} styleClass="avatar" height="80px" />
                                        </span>
                                    </div>
                                )) : "No elevations found" : "No elevations found" : "No elevations found"}
                            </div>
                        </div>
                    </div>
                    {/* File upload button */}
                    <div className="form-group text-left">
                        <label style={formLabelStyle}>Add {commons.drawings}</label>
                        <br />
                        <label htmlFor="editElevationFiles">
                            <span role="button" className="btn btn-outline-dark btn-sm" >
                                Select PDF file(s)
                            </span>
                        </label>
                        <br />
                        <input type="file" className="file" id="editElevationFiles" multiple onChange={this.onFilesAddHandler} style={{ fontWeight: "bold", fontSize: "12px", display: "none" }} />
                    </div>
                    <div style={{ maxHeight: "160px", overflow: "hidden", overflowY: "auto" }}>
                        <ul className="list-group align-items-start list-group-flush">
                            {newFiles.map((fileName, i) => (
                                <li style={{ fontSize: "13px" }} className="list-group-item py-2 border-0" ng-repeat="i in filters" key={i}>
                                    <b>{i + 1}. </b>{`${fileName.name}`}
                                    <br></br>
                                    <span style={{ fontSize: "10px", color: "GrayText", fontStyle: "italic" }}>(Formatted as: {this.processFilenames(fileName.name)})</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                    <hr />
                    {relevantSubmitComponent}
                    <br />
                    <br />
                </form>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        floorMarkers: state.firestore.data.FloorMarkers,
        mut: state.marker,
        formLabelStyle: state.appControl.formLabelStyle,
        sketch: state.sketch,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        commons: state.commons,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateElevation: (markerid, proid, floorid, floorsMap, coordinates, newFiles, title, description) => dispatch(updateElevation(markerid, proid, floorid, floorsMap, coordinates, newFiles, title, description)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditElevation);